import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/local-storage.service';
import { Page } from 'src/app/page';
import { Subject } from 'src/models/subject.model';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { SearchItem } from '../subjects.component';
import { ServiceProviderSubjectService } from 'src/services/service-provider-subject.service';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'app-service-providers-registry',
  templateUrl: './service-providers-registry.component.html',
  styleUrls: ['./service-providers-registry.component.scss']
})
export class ServiceProvidersRegistryComponent implements OnInit, OnChanges {
  @Output() loadingCompleted = new EventEmitter();
  @Output() emitPageData = new EventEmitter();
  @Output() rowClickedEvent = new EventEmitter();
  @Output() handleOpenDialogEvent = new EventEmitter();

  @Input() getFirstPageEvent: any;
  @Input() getPreviousPageEvent: any;
  @Input() getNextPageEvent: any;
  @Input() getLastPageEvent: any;
  @Input() getPageInNewSizeEvent: any;
  @Input() applyFilterEvent: any;
  @Input() changeCenterEvent: any;
  @Input() object: any = { origin: '' };
  @Input() customFilterFormValue: any;
  @Input() filterInUse: boolean = false;

  readonly separatorKeysCodes: number[] = [COMMA, ENTER];
  public searchTerms: string[] = [];

  public globalFilter: any = '';
  public searchItems: SearchItem[] = [];
  page: Page<Subject> = new Page();
  myInput = '';
  displayedColumns: string[] = ['csrCsrName', 'registrationId', 'lastName', 'firstName', 'parentName', 'dateOfBirth', 'jmbg', 'status'];
  fileUrl: any;
  subcenter = new FormControl();
  serviceProviderId: any;
  subcenters = [];
  loggedIn: any;
  areLoaded = false;
  allCsrCodebooks = [];
  filteredSubcenters: Observable<any>;
  paramsObject: any;
  loadParams = true;
  isServiceCoordinator = false;
  primaryRoleServiceCoordinator = false;
  roleLength: any;
  constructor(
    public dialog: MatDialog,
    private paginationService: CustomPaginationService,
    public router: Router,
    private route: ActivatedRoute,
    private serviceProviderSubjectService: ServiceProviderSubjectService,
    private localStorageService: LocalStorageService,
    private userService: UserService
  ) {
    this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
    this.serviceProviderId = this.loggedIn?.serviceProviderId;
    this.isServiceCoordinator = userService.isServiceCoordinator();
    this.primaryRoleServiceCoordinator = this.localStorageService.get('primaryRole') === ' Координатор услуге';
    this.roleLength = JSON.parse(this.localStorageService.get('loggedUser')).role.length;

    if (this.canSeeServiceCoordinatiorActions) {
      this.displayedColumns.push('actions');
    }

    this.getQueryParams();
  }

  get canSeeServiceCoordinatiorActions(): boolean {
    return this.isServiceCoordinator && (this.roleLength === 1 || this.primaryRoleServiceCoordinator);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.getFirstPageEvent) {
      this.getFirstPage();
    } else if (changes.getLastPageEvent) {
      this.getLastPage();
    } else if (changes.getPreviousPageEvent) {
      this.getPreviousPage();
    } else if (changes.getNextPageEvent) {
      this.getNextPage();
    } else if (changes.getPageInNewSizeEvent) {
      this.getPageInNewSize(this.getPageInNewSizeEvent);
    } else if (changes.applyFilterEvent) {
      this.applyFilter(this.applyFilterEvent);
    } else if (changes.changeCenterEvent) {
      this.changeCenter(this.changeCenterEvent);
    }
  }

  ngOnInit(): void {}
  public getNextPage(): void {
    this.areLoaded = false;
    this.loadingCompleted.emit(false);
    this.page.pageable = this.paginationService.getNextPage(this.page);
    this.doFilter();
  }

  public getPreviousPage(): void {
    this.areLoaded = false;
    this.loadingCompleted.emit(false);
    this.page.pageable = this.paginationService.getPreviousPage(this.page);
    this.doFilter();
  }

  public getFirstPage(): void {
    this.areLoaded = false;
    this.loadingCompleted.emit(false);
    this.page.pageable = this.paginationService.getFirstPage(this.page);
    this.doFilter();
  }

  public getLastPage(): void {
    this.areLoaded = false;
    this.loadingCompleted.emit(false);
    this.page.pageable = this.paginationService.getLastPage(this.page);
    this.doFilter();
  }

  public getPageInNewSize(pageSize: any): void {
    this.areLoaded = false;
    this.loadingCompleted.emit(false);
    this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
    this.doFilter();
  }

  doFilter() {
    this.setQueryParams();
    const body = {
      pageId: this.page.pageable.pageNumber,
      sizeId: this.page.pageable.pageSize,
      serviceProviderId: this.serviceProviderId,
      searchData: (this.globalFilter === '' ? this.myInput : this.globalFilter) === '' ? [] : this.globalFilter === '' ? this.myInput : this.globalFilter,
      status: this.filterInUse ? this.customFilterFormValue.status : null,
      address: this.filterInUse && this.customFilterFormValue.address != '' ? this.customFilterFormValue.address : null,
      providedService: this.filterInUse && this.customFilterFormValue.providedServices != null ? this.customFilterFormValue.providedServices : null
    };
    this.serviceProviderSubjectService.getFilteredPage(body).subscribe(page => {
      this.page = page;
      this.page.pageable.pagePerShow = page.number + 1;
      for (const element of this.page.content) {
        if (element.dateOfBirth !== null) {
          element.dateOfBirth = (element.dateOfBirth as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
        }
      }
      this.emitPageData.emit(this.page);
      this.loadingCompleted.emit(true);
      this.areLoaded = true;
    });
  }

  setQueryParams() {
    let params = {
      pageNum: null,
      size: null,
      filter: this.globalFilter === '' ? null : this.globalFilter,
    };
    if (this.object.origin === undefined) {
      if (this.page.pageable.pageNumber !== 0) {
        params = {
          pageNum: this.page.pageable.pageNumber,
          size: this.page.pageable.pageSize,
          filter: this.globalFilter === '' ? null : this.globalFilter,
        };
      }
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        replaceUrl: true,
      });
    }
  }

  getQueryParams() {
    this.route.queryParamMap.subscribe(params => {
      if (this.loadParams === true) {
        this.paramsObject = { ...params.keys, ...params };
        const param = this.paramsObject.params;
        this.page.pageable.pageNumber = param?.pageNum ? param?.pageNum : this.page.pageable.pageNumber;
        this.page.pageable.pageSize = param?.size ? param?.size : this.page.pageable.pageSize;

        if (param?.filter) {
          this.searchItems = [];
          this.globalFilter = Array.isArray(param?.filter) ? param?.filter : [param?.filter];
          for (const filter of this.globalFilter) {
            this.searchItems.push({ name: filter });
          }
        }
        this.loadParams = false;
      }
    });
  }

  handleOpenDialog(element: any) {
    this.handleOpenDialogEvent.emit(element);
  }

  onRowClicked(element: any) {
    this.rowClickedEvent.emit(element);
  }

  applyFilter(filterValue: any) {
    this.globalFilter = filterValue;
    this.page.pageable.pageNumber = 0;
    this.doFilter();
  }

  changeCenter(event: any) {
    this.serviceProviderId = event?.id;
    this.getFirstPage();
  }

}
